import { Loc } from 'main.core';
import { NoticeBase } from 'b24network.vue.cross-scenario-shared-js';

/**
 * When user tries to use an invite that was cancelled/deactivated
 */
export class InviteCancelled extends NoticeBase
{
	constructor()
	{
		super(
			Loc.getMessage('EXT_B24NET_LOGGING_IN_ASK_B24_ADMIN'),
			Loc.getMessage('EXT_B24NET_LOGGING_IN_INVITE_CANCELLED'),
		);
	}
}
